"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentService = void 0;
const PaymentServiceLive_1 = require("./PaymentServiceLive");
const PaymentServiceStub_1 = require("./PaymentServiceStub");
class PaymentService {
    static create(stub) {
        if (stub) {
            return new PaymentServiceStub_1.PaymentServiceStub();
        }
        return new PaymentServiceLive_1.PaymentServiceLive();
    }
}
exports.PaymentService = PaymentService;
//# sourceMappingURL=PaymentService.js.map